import isPes from "src/helpers/isPes";
import { http } from "src/newApi";

export interface FaqItem {
	id: number;
	content: string;
	order: number;
	faqContentId: number;
	createdAt: string;
	updatedAt: string;
}

export interface FaqContent {
	id: number;
	name: string;
	order: number;
	// pes: specId = null, czyli poradnik wspólny dla wszystkich specjalizacji
	isGlobal: boolean;
	createdAt: string;
	updatedAt: string;
	items: FaqItem[];
}

export const faqPrefix = () => (isPes() ? "/pes" : "");

export function getFaq(): Promise<FaqContent[]> {
	return http.get(`/v1${faqPrefix()}/faq`).then(({ data }) => data);
}
